import {
  mapMobileApiHttpError,
  mobileApiFetch,
} from '@/mobile/native/mobileApiFetch';
import type {
  FieldBootstrapResponse,
  FieldSyncPushOperation,
  FieldSyncResponse,
} from '@/mobile/sync/fieldSyncTypes';

async function parseJson<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const text = await response.text();
    throw new Error(mapMobileApiHttpError(response.status, text));
  }

  return response.json() as Promise<T>;
}

export async function fetchFieldBootstrap(): Promise<FieldBootstrapResponse> {
  const response = await mobileApiFetch('/api/field/bootstrap', {
    method: 'GET',
  });

  return parseJson<FieldBootstrapResponse>(response);
}

export async function postFieldSync(body: {
  deviceId?: string;
  lastPullAt?: string | null;
  push?: FieldSyncPushOperation[];
  /** false = só processa push (APK em background). */
  pull?: boolean;
}): Promise<FieldSyncResponse> {
  const response = await mobileApiFetch('/api/field/sync', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  return parseJson<FieldSyncResponse>(response);
}
